import { render } from "./IconDrawer.vue?vue&type=template&id=0ff5b972&scoped=true"
import script from "./IconDrawer.vue?vue&type=script&lang=js"
export * from "./IconDrawer.vue?vue&type=script&lang=js"

import "./IconDrawer.vue?vue&type=style&index=0&id=0ff5b972&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff5b972"]])

export default __exports__